import React, {useEffect, useRef} from "react";
import {useCursor} from "./MagicCursorProvider";
import "./MagicCursor.css";
import gsap from "gsap";

const MagicCursor = () => {
  const ballRef = useRef(null);
  const viewTextRef = useRef(null);
  const {cursorStyle, cursorText} = useCursor();

  useEffect(() => {
    const ball = ballRef.current;

    if (!ball) return;

    let x = window.innerWidth / 2;
    let y = window.innerHeight / 2;
    let mouseX = x;
    let mouseY = y;

    const speed = 0.2;

    const handleMouseMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const animate = () => {
      x += (mouseX - x) * speed;
      y += (mouseY - y) * speed;
      gsap.set(ball, {
        x: x - ball.offsetWidth / 2,
        y: y - ball.offsetHeight / 2,
      });
      requestAnimationFrame(animate);
    };

    document.body.classList.add("tt-magic-cursor");
    window.addEventListener("mousemove", handleMouseMove);
    animate();

    return () => {
      document.body.classList.remove("tt-magic-cursor");
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  // Animate text appearance
  useEffect(() => {
    const textEl = viewTextRef.current;
    const ball = ballRef.current;

    // Animate ball-view text
    if (cursorStyle === "ball-view" && textEl) {
      gsap.to(textEl, {
        scale: 1,
        opacity: 1,
        duration: 0.2,
        ease: "power3.out",
      });

      // 👇 Also grow the ball
      gsap.to(ball, {
        width: 150,
        height: 150,
        duration: 0.2,
        ease: "power3.out",
      });
    } else {
      gsap.to(textEl, {
        scale: 0,
        opacity: 0,
        duration: 0.2,
        ease: "power3.in",
      });

      // 👇 Reset ball size
      gsap.to(ball, {
        width: 36,
        height: 36,
        duration: 0.2,
        ease: "power3.inOut",
      });
    }
  }, [cursorStyle, cursorText]);

  return (
    <div id="ball" ref={ballRef} className={cursorStyle}>
      <div
        className="ball-view-inner"
        ref={viewTextRef}
        dangerouslySetInnerHTML={{__html: cursorText}}
      />
    </div>
  );
};

export default MagicCursor;
